import axios, { AxiosRequestConfig } from 'axios';
import { promiseAOP } from '../common';

declare module 'axios' {
  // eslint-disable-next-line no-unused-vars
  interface AxiosRequestConfig {
    useCancelToken?: boolean;
  }
  // eslint-disable-next-line no-unused-vars
  interface AxiosResponse {
    useCancelToken?: boolean;
  }
}
// 拦截请求，统一处理参数，公共header
// 统一错误异常捕获+统一状态处理
// 统一拦截重复请求
// 可控 可收敛

const cancelObj: any = {};
const CancelToken = axios.CancelToken;
/**
 *
 * @param config AxiosRequestConfig
 * @returns key 请求的唯一标识
 */
function getRequestUniqueKey (config: AxiosRequestConfig<any>): string {
  return (
    (config.baseURL as string) +
    config.url +
    (config.params ? JSON.stringify(config.params) : '') +
    (config.data ? JSON.stringify(config.data) : '')
  );
}
/**
 * 等待逻辑处理
 * @param config  axios config
 * @param isRequest 是否是请求阶段过来的
 */
function waitLogic (key: string, isRequest?: boolean) {
  if (cancelObj[key] && isRequest) {
    cancelObj[key](key);
  }
  delete cancelObj[key];
}

// 请求等待中间件
function requestWaitMiddleware (config: AxiosRequestConfig) {
  const key: string = getRequestUniqueKey(config);
  waitLogic(key, true);
  config.cancelToken = new CancelToken((c) => {
    cancelObj[key] = c;
  });
}
// 响应等待中间件处理
function responseWaitMiddleware (config: AxiosRequestConfig) {
  const key: string = getRequestUniqueKey(config);
  waitLogic(key);
}
// 统一异常处理
function errorMiddleware (error: any) {
  return Promise.reject(error);
}

axios.interceptors.request.use(
  (config) => {
    // config.params  统一参数增加
    // config.params = config.params || {};
    // config.params.feV = '6';
    // 统一请求头增加header等处理
    // 拦截重复请求
    if (config.useCancelToken) {
      requestWaitMiddleware(config);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * 相应拦截
 */
axios.interceptors.response.use((config) => {
  if (config.useCancelToken) {
    responseWaitMiddleware(config);
  }
  // 响应处理
  return config;
}, errorMiddleware);

const http = axios.create();
// 实例拦截器
http.interceptors.request.use(
  (config) => {
    // config.params  统一参数增加
    // config.params = config.params || {};
    // config.params.feV = '6';
    // 统一请求头增加header等处理
    // 拦截重复请求
    if (config.useCancelToken) {
      requestWaitMiddleware(config);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 实例拦截器
http.interceptors.response.use((config) => {
  if (config.useCancelToken) {
    responseWaitMiddleware(config);
  }
  // 响应处理
  return config;
}, errorMiddleware);

/** AOP 切片拦截  request 方法  */
const originRequest = axios.Axios.prototype.request;
axios.Axios.prototype.request = promiseAOP(
  originRequest,
  function (this: { defaults: AxiosRequestConfig }, config: any) {
    // console.log('use ynf-core-middleware before');
    if (this.defaults.headers) {
      // this.defaults.headers['A'] = '1000';
    }
  },
  function (config: any) {
    // console.log('use ynf-core-middleware after');
  }
);

export { http };
export default axios;

// // 导出 代理对象
// let proxyAxios = new Proxy(axios, {
//   get(target, p, receiver) {
//     return Reflect.get(target, p);
//   },
//   set(target, p, value, receiver) {
//     return true;
//   },
//   apply(target, object, args: any) {
//     if (target.defaults.headers) {

//         (target.defaults as any).A=1000
//       // target.defaults.headers.A="100"
//     }
//     return target.apply(object, args);
//   },
// });
